'use strict';

module.exports = {
  DISPATCHER_ID: 'Global' // default DispatcherId
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/flux/src/config.js